import axios from "@/lib/axios";

const searchCustomers = (status: string, facilityId: number | undefined) => {
  return axios.get(`/facility/facility_agreements/customers/search?status=${status}&facility_id=${facilityId}`);
}

export default searchCustomers;